import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import InsuranceExportBlank, {InsuranceExportBlankStatus} from "@/shared/model/InsuranceExportBlank";
import {computed} from "vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";

interface Props {
  insuranceExportBlank: InsuranceExportBlank
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'StoreItemInsuranceExportBlankCardComponent',
  props: {
    insuranceExportBlank: {}
  },
  setup(__props: any) {


const props = __props

const _title = computed(() => {
  return (props.insuranceExportBlank.insuranceNumber ? (props.insuranceExportBlank.insuranceNumber + " - ") : "") + props.insuranceExportBlank.blankNumber;
})

const _class = computed(() => {
  return (props.insuranceExportBlank.status === InsuranceExportBlankStatus.IncorrectlyFilled) ? "deleted" : "";
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, {
        class: _normalizeClass(_class.value)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_title.value), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})